let CampaignsIndexTourSteps  = {
  tourSteps: function() {
    return [
        {
          content: 'The workflows page lists the workflows you have created.',
          target: '.help_icon_smaller',
          placement: 'bottom',
          disableBeacon: true
        },
        {
          content: 'Use this button to create a new workflow.',
          target: '.new_campaign_btn',
          placement: 'bottom',
          disableBeacon: true
        },
        {
          content: "This is the name of the workflow.",
          target: '.campaign_name',
          placement: 'top',
          disableBeacon: true
        },
        {
          content: "This is the current status of workflow. A workflow is in draft mode until you publish it.",
          target: '.campaign_status',
          placement: 'top',
          disableBeacon: true
        },
        {
          content: "This is the number of steps in a workflow.",
          target: '.campaign_steps',
          placement: 'top',
          disableBeacon: true
        },
        {
          content: "This is the number of leads currently subscribed to the workflow.",
          target: '.campaign_leads',
          placement: 'top',
          disableBeacon: true
        },
        {
          content: "This is the number of times emails from this workflow have been queued for delivery.",
          target: '.campaign_email_stats_queued',
          placement: 'top',
          disableBeacon: true
        },
        {
          content: "This is the number of times emails from this workflow have been delivered.",
          target: '.campaign_email_stats_delivered',
          placement: 'top',
          disableBeacon: true
        },
        {
          content: "This is the number of times emails from this workflow have been opened.",
          target: '.campaign_email_stats_opened',
          placement: 'top',
          disableBeacon: true
        },
        {
          content: "This is the number of times emails from this workflow have been clicked.",
          target: '.campaign_email_stats_clicked',
          placement: 'top',
          disableBeacon: true
        },
        {
          content: "This is the number of times a customer has unsubscribed using an email from this workflow.",
          target: '.campaign_email_stats_unsubscribed',
          placement: 'top',
          disableBeacon: true
        },
        {
          content: "This is the number of times a customer has submitted a spam report using an email from this workflow.",
          target: '.campaign_email_stats_spam_report',
          placement: 'top',
          disableBeacon: true
        },
        {
          content: "This is the number of times an email from this workflow has bounced. Common reasons for emails bouncing are incorrect addresses or full mailboxes.",
          target: '.campaign_email_stats_bounced',
          placement: 'top',
          disableBeacon: true
        },
        {
          content: "This is the number of times an email from this workflow has failed to send. Common reasons for email failures are incorrect addresses or full mailboxes.",
          target: '.campaign_email_stats_failed',
          placement: 'top',
          disableBeacon: true
        },
        {
          content: "Click here to edit a workflow.",
          target: '.campaign_edit',
          placement: 'top',
          disableBeacon: true
        }
    ];
  }
};

export default CampaignsIndexTourSteps;
